import { render, staticRenderFns } from "./ymkWrap.vue?vue&type=template&id=4ba9edea&lang=pug&"
import script from "./ymkWrap.vue?vue&type=script&lang=js&"
export * from "./ymkWrap.vue?vue&type=script&lang=js&"
import style0 from "./ymkWrap.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports